import React from 'react'
import PropTypes from 'prop-types'
import { polyglot } from '../../../index'
import { Panel } from '../../common/Panel/Panel'
import { SingleLineTable } from '../../common/SingleLineTable/SingleLineTable'
import moment from 'moment/moment'

const dateFormat = {
  standartData: 'yyyy-MM-dd'
}

const Notes = ({savedObjects, handleSubmit, handleChange, config, doctorName, patientBirthDate}) => {
  let status = 'panel-default'
  if (savedObjects && Object.keys(savedObjects).length > 0) {
    status = 'panel-warning'
  }
  return <Panel heading={polyglot.t('staticFields.home.notes.notes')} panelType={status}>
    <SingleLineTable
      minDateForCalendar={patientBirthDate}
      maxDateForCalendar={moment().format(dateFormat.standartData)}
      doctorName={doctorName}
      config={config}
      handleChange={handleChange}
      insertionButtonText={polyglot.t('staticFields.home.notes.add')}
      nameOfModal={polyglot.t('staticFields.home.notes.register')}
      insertionFieldDescription={polyglot.t('staticFields.home.notes.description')}
      data={savedObjects}
      handleSubmit={handleSubmit} />
  </Panel>
}

Notes.propTypes = {
  savedObjects: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  doctorName: PropTypes.string,
  patientBirthDate: PropTypes.string
}

export default Notes



// WEBPACK FOOTER //
// ./src/components/general/Home/Notes.js